import { render, staticRenderFns } from "./ModalKitOpme.vue?vue&type=template&id=44b1cfa8&scoped=true"
import script from "./ModalKitOpme.vue?vue&type=script&lang=ts"
export * from "./ModalKitOpme.vue?vue&type=script&lang=ts"
import style0 from "./ModalKitOpme.vue?vue&type=style&index=0&id=44b1cfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1cfa8",
  null
  
)

export default component.exports